/**
 * Cheap-version boost-candidate ranker.
 *
 * Returns posts outperforming the client's own engagement-rate baseline
 * with a suggested per-post budget. No agent calls — pure DB rollup.
 * Distinct from `useBoostRecommendation` which runs Claude per post.
 */

import { useQuery } from "@tanstack/react-query";

import { adsService } from "../services/adsService";
import type { BoostCandidatesView } from "../types";

const EMPTY: BoostCandidatesView = {
  clientId: "",
  currency: "EUR",
  remainingBudget: 0,
  perCampaignCap: null,
  baselinesByPostType: {},
  candidates: [],
};

export function useBoostCandidates(clientId: string | undefined) {
  return useQuery({
    queryKey: clientId
      ? ["ads", "boost-candidates", clientId]
      : ["ads", "boost-candidates", "none"],
    queryFn: async (): Promise<BoostCandidatesView> => {
      if (!clientId) return EMPTY;
      return adsService.getBoostCandidates(clientId);
    },
    enabled: !!clientId,
    staleTime: 5 * 60_000,
  });
}
